import { render } from "./mainAccountContent.vue?vue&type=template&id=06693322"
import script from "./mainAccountContent.vue?vue&type=script&lang=js"
export * from "./mainAccountContent.vue?vue&type=script&lang=js"

import "./mainAccountContent.vue?vue&type=style&index=0&id=06693322&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__